import { render, staticRenderFns } from "./PackingListTable.vue?vue&type=template&id=6418fbfa&scoped=true"
import script from "./PackingListTable.vue?vue&type=script&lang=js"
export * from "./PackingListTable.vue?vue&type=script&lang=js"
import style0 from "./PackingListTable.vue?vue&type=style&index=0&id=6418fbfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418fbfa",
  null
  
)

export default component.exports